export enum HouseType {
    MEDIUM_HOUSE = 'MEDIUM_HOUSE',
    LARGE_HOUSE = 'LARGE_HOUSE',
}
